import gql from "graphql-tag";

export default gql(`
  mutation addInviteRecord($formid: ID!, $userid: ID!, $created_at: String!, $phone: String, $email: String) {
    addInviteRecord (formid: $formid, userid: $userid, created_at: $created_at, phone: $phone, email: $email ){
        id
      }
  }`);
